<div class="filter-header" (click)="toggleExpanded()">
  @if (icon(); as icon) {
    <mat-icon class="filter-header__icon material-icons-outlined" [mpIcon]="icon" />
  }

  <div class="filter-header__title">
    @if (filterNameTemplate(); as filterNameTemplate) {
      <ng-template [ngTemplateOutlet]="filterNameTemplate" />
    } @else {
      <span class="truncate" [title]="filterName()">{{ filterName() }}</span>
    }
  </div>

  @if (!isExpanded()) {
    <ng-content select="[filter-group-selection-info]" />
  }

  <div class="filter-header-actions">
    @if (isExpanded()) {
      <ng-content select="[filter-group-clear-filter-action]" />
    }

    @if (searchable() && isExpanded()) {
      <button
        mat-icon-button
        class="filter-header-actions__search-button"
        aria-label="Toggle Search"
        (click)="$event.stopPropagation(); toggleSearchExpanded()"
      >
        <mat-icon>{{ isSearchExpanded() ? 'close' : 'search' }}</mat-icon>
      </button>
    }

    <button class="filter-header-actions__toggle-button" mat-icon-button aria-label="Expand Panel">
      <mat-icon>{{ isExpanded() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </button>
  </div>
</div>

@if (searchable() && isExpanded() && isSearchExpanded()) {
  <div class="filter-search-field-container">
    @if (customSearchTemplate(); as customSearchTemplate) {
      <ng-template [ngTemplateOutlet]="customSearchTemplate" />
    } @else {
      <mp-filter-search-field
        class="filter-search-field"
        #searchField
        [searchFieldPlaceholder]="searchFieldPlaceholder()"
        (searched)="executeSearch($event)"
      />
    }
  </div>
}

@if (isExpanded()) {
  <div class="filter-options-list">
    <ng-content />
  </div>
}
